import docCookies from 'doc-cookies';
import { load } from 'recaptcha-v3';
import { BASE_URL_SANCTUM } from '../misc/consts';

const RECAPTCHA_SITE_KEY = process.env.MIX_RECAPTCHA_SITE_KEY;

export default (fullReset = true) => ({
  form: null,
  sent: false,
  sending: false,
  failed: false,

  init() {
    this.form = this.$el;
  },

  get action() {
    return this.form.action;
  },

  async getXsfrToken() {
    const response = await fetch(BASE_URL_SANCTUM);
    if (!response.ok) {
      throw new Error(`Error! status: ${response.status}`);
    }
  },

  resetForm() {
    this.form.reset();
  },

  isValid() {
    return this.form.reportValidity();
  },

  async getRecaptchaToken(action) {
    if (
      !RECAPTCHA_SITE_KEY ||
      RECAPTCHA_SITE_KEY === 'your_recaptcha_site_key_here'
    ) {
      return 'dev-token';
    }
    const recaptcha = await load(RECAPTCHA_SITE_KEY);
    return await recaptcha.execute(action);
  },

  async send() {
    if (!this.isValid()) {
      return false;
    }
    this.sending = true;
    try {
      await this.getXsfrToken();

      const data = new URLSearchParams(new FormData(this.form));
      const recaptchaAction = this.action.replace(/[^A-Za-z]/g, '');
      const token = await this.getRecaptchaToken(recaptchaAction);
      data.append('recaptcha_token', token);
      data.append('recaptcha_action', recaptchaAction);

      return this.doFetch(data);
    } catch (error) {
      this.sending = false;
      console.error('Error:', error);
      throw error;
    }
  },

  doFetch(data) {
    return fetch(this.action, {
      body: data,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
      },
      method: 'POST',
    })
      .then(async (response) => {
        if (response.ok) {
          this.resetForm();
          this.sent = true;
          this.sending = false;
          return;
        }

        // A refused submission (validation, a listener saying no) used to
        // leave the button spinning forever. Hand the reasons to whoever
        // wraps the form instead.
        const body = await response.json().catch(() => ({}));
        this.sending = false;
        this.$dispatch('async-form-error', {
          status: response.status,
          errors: body.error ?? {},
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        this.sent = true;
        this.failed = true;
        this.sending = false;
      })
      .finally(() => {
        if (fullReset) {
          this.sent = false;
        }
        setTimeout(() => {
          this.$dispatch('modal:close');
        }, 3100);
      });
  },
});
